import classes from "./AboutSeo.module.scss"
import BoldTitle from '../../../Titles/BoldTitle/BoldTitle';
import Cards from "../../../Cards/Cards";
import CirclePink from '../../../CirclePink/CirclePink';

let secondList = [{
  number: "01.",
  title: "Не все страницы \n сайта находились \u00A0в индексе",
},
{
  number: "02.",
  title: "Роста органического трафика не было уже\n на протяжении длительного \nпериода времени.",
},{
  number: "03.",
  title: "Конверсия сайта\n была примерно в\n 1,5 раза ниже, чем средняя по\n отрасли.",
},{
  number: "04.",
  title: "Посещаемость из поисковых систем не превышала в 18 году 1 700  человек в месяц.",
  text: "Из Я. Директ не более 3 300. Общий трафик не превышал 6000 переходов в месяц. Данные по email-рассылкам отсутствовали.",
},]

function AboutSeo() {
  return (
    <div className={classes.aboutSeo}>
      <CirclePink customClass={classes.CirclePink}/>
      <BoldTitle
           text={<>Что касается <span>сайта</span> и <span>SEO</span>, то мы зафиксировали следующую проблематику:</>}
           customClass={classes.Title}
         />
      <div className={classes.List}>
        {secondList.map((elem, i) => {
          return <Cards number={elem.number} key={i} title={elem.title} customClass={classes.Item} text={elem.text} />
        })}
      </div>
    </div>
  )
}

export default AboutSeo;